import '@style/product.scss';
import creator from '@utils/creator.js';

import SliderProductGallery from '@components/SliderProductGallery';
import DeliveryNotice from '@components/DeliveryNotice';
import ProductStickyBar from '@components/ProductStickyBar';
import AnchorEnvironment from '@components/AnchorEnvironment.js';
import ProductReview from '@components/ProductReview.js';
import ProductReviewsIO from '@components/ProductReviewsIO.js';

function ClrzAppInit() {
	ClrzApp.SliderProductGallery = creator(
		'.js-slider-product-gallery',
		SliderProductGallery,
	);
	customElements.define('delivery-notice', DeliveryNotice);
	ClrzApp.ProductStickyBar = creator('.js-product-sticky', ProductStickyBar);
	ClrzApp.AnchorEnvironment = creator(
		'.js-anchor-environment',
		AnchorEnvironment,
	);
	customElements.define('product-reviews-io', ProductReviewsIO);
	customElements.define('product-review', ProductReview);
}

ClrzAppInit();
